import React, { useState } from 'react';
import { FaEllipsisV, FaChartBar, FaExpand, FaList, FaDownload } from 'react-icons/fa'; // Import necessary icons

// Fallback data for the Influencer table
const FALLBACK_INFLUENCERS = [
  { id: 1, name: 'Charlotte Austin', handle: '@itscharlotte', network: 'X', networkValue: 100, reach: '11.1M', reachPerMention: '11.1M', engagement: '11.1M', engagementPerMention: '11.1M' },
  { id: 2, name: 'Charlotte Austin', handle: '@itscharlotte', network: 'X', networkValue: 100, reach: '11.1M', reachPerMention: '11.1M', engagement: '11.1M', engagementPerMention: '11.1M' },
  { id: 3, name: 'Charlotte Austin', handle: '@itscharlotte', network: 'X', networkValue: 100, reach: '11.1M', reachPerMention: '11.1M', engagement: '11.1M', engagementPerMention: '11.1M' },
  { id: 4, name: 'Charlotte Austin', handle: '@itscharlotte', network: 'X', networkValue: 100, reach: '11.1M', reachPerMention: '11.1M', engagement: '11.1M', engagementPerMention: '11.1M' },
  { id: 5, name: 'Charlotte Austin', handle: '@itscharlotte', network: 'X', networkValue: 100, reach: '11.1M', reachPerMention: '11.1M', engagement: '11.1M', engagementPerMention: '11.1M' },
  { id: 6, name: 'Charlotte Austin', handle: '@itscharlotte', network: 'X', networkValue: 100, reach: '11.1M', reachPerMention: '11.1M', engagement: '11.1M', engagementPerMention: '11.1M' },
  { id: 7, name: 'Charlotte Austin', handle: '@itscharlotte', network: 'X', networkValue: 100, reach: '11.1M', reachPerMention: '11.1M', engagement: '11.1M', engagementPerMention: '11.1M' },
  { id: 8, name: 'Charlotte Austin', handle: '@itscharlotte', network: 'X', networkValue: 100, reach: '11.1M', reachPerMention: '11.1M', engagement: '11.1M', engagementPerMention: '11.1M' },
  { id: 9, name: 'Charlotte Austin', handle: '@itscharlotte', network: 'X', networkValue: 100, reach: '11.1M', reachPerMention: '11.1M', engagement: '11.1M', engagementPerMention: '11.1M' },
  { id: 10, name: 'Charlotte Austin', handle: '@itscharlotte', network: 'X', networkValue: 100, reach: '11.1M', reachPerMention: '11.1M', engagement: '11.1M', engagementPerMention: '11.1M' },
];

// Fallback data for Share of Media Type chart labels
const FALLBACK_MEDIA_TYPES = [
  { label: 'Twitter', color: '#1DA1F2' },
  { label: 'Blue Sky', color: '#0072E1' },
  { label: 'Youtube', color: '#FF0000' },
  { label: 'Paper', color: '#4CAF50' },
  { label: 'Blog', color: '#FF9800' },
  { label: 'Other', color: '#9E9E9E' },
  { label: 'Tv', color: '#3F51B5' },
  { label: 'Radio', color: '#00BCD4' },
  { label: 'Magazine', color: '#E91E63' },
];

export default function InfluencerPage({ query, setQuery, onSelectInfluencer }) {
  const [localQuery, setLocalQuery] = useState(query);

  // This handleSearch will update the main query state in DashboardApp
  const handleSearch = () => {
    if (setQuery && localQuery.trim() !== '') {
      setQuery(localQuery.trim());
    }
  };

  return (
    <div className="influencer-page" style={{ padding: '2rem' }}>
      <h2>Influencer</h2>

      <div className="influencer-content-grid" style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '2rem' }}>
        {/* Left Side: Unique Author & Media Type Chart */}
        <div className="influencer-left-panel" style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
          {/* Unique Author Card */}
          <div className="influencer-card">
            <div className="influencer-card-header">
              <h3>Unique Author</h3>
              <div className="influencer-card-icons">
                <FaExpand />
                <FaChartBar />
                <FaList />
                <FaEllipsisV />
              </div>
            </div>
            <div className="influencer-card-value">
              15.6K {/* Fallback Value */}
            </div>
          </div>

          {/* Share Of Media Type Chart (Placeholder) */}
          <div className="influencer-card">
             <div className="influencer-card-header">
              <h3>Share Of Media Type</h3>
              <div className="influencer-card-icons">
                 <FaExpand />
                 <FaChartBar />
                 <FaList />
                 <FaEllipsisV />
              </div>
            </div>
            <div className="influencer-chart-placeholder" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
               {/* Placeholder for the donut chart */}
               <div style={{ width: 150, height: 150, borderRadius: '50%', background: '#0d264d', border: '30px solid #e0e0e0' }}></div>
            </div>
            <div className="influencer-media-type-legend" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '1rem', fontSize: '0.9rem' }}>
                {FALLBACK_MEDIA_TYPES.map((type, index) => (
                    <div key={index} style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                        <span style={{ display: 'inline-block', width: '10px', height: '10px', borderRadius: '50%', background: type.color, marginRight: '4px' }}></span>
                        {type.label}
                    </div>
                ))}
            </div>
          </div>
        </div>

        {/* Right Side: Influencer Table */}
        <div className="influencer-right-panel">
           <div className="influencer-card">
             <div className="influencer-card-header">
               <h3>Influencer</h3>
               <div className="influencer-card-icons">
                 <FaDownload />
                 <FaExpand />
                 <FaList />
                 <FaEllipsisV />
               </div>
             </div>
             <div className="influencer-table-container">
               <table>
                 <thead>
                   <tr>
                     <th>Influencer</th>
                     <th>Network</th>
                     <th>Network</th> {/* Duplicate header as in SS */}
                     <th>Reach</th>
                     <th>Reach Per Mention</th>
                     <th>Engagement</th>
                     <th>Engagement Per Mention</th>
                   </tr>
                 </thead>
                 <tbody>
                   {FALLBACK_INFLUENCERS.map(influencer => (
                     <tr key={influencer.id} onClick={() => onSelectInfluencer(influencer)} style={{ cursor: 'pointer' }}>
                       <td>
                         <div style={{ display: 'flex', alignItems: 'center' }}>
                            {/* Placeholder for profile pic */}
                            <div style={{ width: 24, height: 24, borderRadius: '50%', background: '#ccc', marginRight: 8 }}></div>
                            <div>
                                <div>{influencer.name}</div>
                                <div style={{ fontSize: '0.8rem', color: '#666' }}>{influencer.handle}</div>
                            </div>
                         </div>
                       </td>
                       <td>{influencer.network}</td>
                       <td>{influencer.networkValue}</td>
                       <td>{influencer.reach}</td>
                       <td>{influencer.reachPerMention}</td>
                       <td>{influencer.engagement}</td>
                       <td>{influencer.engagementPerMention}</td>
                     </tr>
                   ))}
                 </tbody>
               </table>
             </div>
           </div>
        </div>
      </div>
    </div>
  );
} 